'use client';

import { useMemo } from 'react';
import type { Game } from '@/types/games';
import type { RotatingTitles } from '@/types/zones/zone';
import { useGlobalContext } from '@/store/contexts/global-context';
import { GamesGridZone } from '@/app/components/zones/layouts/games-grid/games-grid-zone';
import { COLLECTION_ZONE_LAYOUT, PRISMIC_ZONE_LAYOUT, ZONE_SLICE_TYPES } from '@/app/constants/zone';
import { getZoneGames } from '@/logic/games/zone-games';
import { useNewCategory } from '@/app/components/zones/contexts/new-category-context';

interface NewToYouZoneProps {
    title: string | undefined;
    gridLayout?: PRISMIC_ZONE_LAYOUT;
    items: Game[];
    rotatingTitles?: RotatingTitles;
    zoneUid?: string;
}

export const NewToYouZone = ({
    title,
    gridLayout = PRISMIC_ZONE_LAYOUT.DEFAULT,
    items,
    rotatingTitles,
    zoneUid
}: NewToYouZoneProps) => {
    const { isLoggedIn } = useGlobalContext();
    const { newToYouUIDs } = useNewCategory();

    const games = useMemo(() => items.filter((game) => newToYouUIDs.has(game.uid)), [items, newToYouUIDs]);

    if (!games.length) {
        return null;
    }

    const zoneLayout = COLLECTION_ZONE_LAYOUT[gridLayout];
    const { games: gameViewModels, tracking } = getZoneGames(games, gridLayout);

    return (
        <GamesGridZone
            games={gameViewModels}
            tracking={tracking}
            gridLayout={gridLayout}
            hideGameInfo={gridLayout !== PRISMIC_ZONE_LAYOUT.DEFAULT || isLoggedIn}
            meta={{
                title,
                rotatingTitles,
                zoneUid,
                zoneType: ZONE_SLICE_TYPES.CASINO_DYNAMIC_ZONE,
                bannerId: ZONE_SLICE_TYPES.CASINO_DYNAMIC_ZONE,
                zoneName: title ?? '',
                zoneLayout,
                isDynamicOrdering: false
            }}
        />
    );
};
